export interface Vibe {
  id: string;
  name: string;
  description: string;
  emoji: string;
  color: string;
  display_order: number;
}

export interface SubCategory {
  id: string;
  name: string;
  vibe_id: string;
  display_order: number;
}

export interface EventVibe {
  event_id: string;
  vibe_id: string;
  is_primary: boolean;
}

// Vibe colors for quick access
export const VIBE_COLORS: Record<string, string> = {
  MOVE: '#C4714A',
  CALM: '#C4714A',
  CONNECT: '#C4714A',
  HEAL: '#C4714A',
  NOURISH: '#C4714A',
  CREATE: '#C4714A',
  RETREAT: '#C4714A',
};

// Default vibes (in case DB doesn't load)
export const DEFAULT_VIBES: Vibe[] = [
  { id: 'MOVE', name: 'Move', description: 'High energy, physical flow, and body awareness.', emoji: '🏃', color: '#C4714A', display_order: 1 },
  { id: 'CALM', name: 'Calm', description: 'Stillness, nervous system regulation, and grounding.', emoji: '🧘', color: '#C4714A', display_order: 2 },
  { id: 'CONNECT', name: 'Connect', description: 'Belonging, shared experience, and safe spaces.', emoji: '🤝', color: '#C4714A', display_order: 3 },
  { id: 'HEAL', name: 'Heal', description: 'Ritual, emotional release, and holistic recovery.', emoji: '💚', color: '#C4714A', display_order: 4 },
  { id: 'NOURISH', name: 'Nourish', description: 'Practical growth, fueling the body, and learning skills.', emoji: '🥗', color: '#C4714A', display_order: 5 },
  { id: 'CREATE', name: 'Create', description: 'Expression, flow, imagination, and making.', emoji: '🎨', color: '#C4714A', display_order: 6 },
  { id: 'RETREAT', name: 'Retreat', description: 'Deep immersion, perspective shifts, and multi-day growth.', emoji: '🏔️', color: '#C4714A', display_order: 7 },
];
